import { createIcon } from './createIcon'

export const ConversationsIcon = createIcon({
  displayName: 'ConversationsIcon',
  viewBox: '0 0 20 20',
  path: [
    <path
      d="M10 1C5.02965 1 1 4.32843 1 8.43478C1.02087 9.45713 1.27076 10.4618 1.73125 11.3748C2.19175 12.2878 2.85113 13.0859 3.66087 13.7103L1.78261 18.2174L6.76939 15.3679C7.81402 15.7004 8.90373 15.8696 10 15.8696C14.9703 15.8696 19 12.5411 19 8.43478C19 4.32843 14.9703 1 10 1Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />,
  ],
})
